import { t } from "i18next";

const GetRequestStyle = (status,type='label') => {

    let label;
    let heading;
    let color;
    let bgColor;

    switch (status) {
        case 'pending-favorite-worker-approval':
            label = t('pendingApproval');
            heading = t('reqNeedsApproval');
            color = 'text-orange';
            bgColor = 'bg-orange'; 
            break; 
        case 'pending-vendor-assignment':
            label = t('pendingApproval');
            heading = t('reqNeedsApproval');
            color = 'text-orange';
            bgColor = 'bg-orange';
            break;
        case 'reviewed':
            label = t('requestReviewed');
            heading = t('reqIsReviewed');
            color = 'text-success';
            bgColor = 'bg-success';
            break;
        case 'postponed':
            label = t('postponed');
            heading = t('reqPostponed');
            color = 'text-orange';
            bgColor = 'bg-orange';
            break;
        case 'pending-approval':
            label = t('pendingManagerDec');
            heading = t('reqManagerReview');
            color = 'text-pandingOps';
            bgColor = 'bg-pandingOps';
            break;
        case 'pending-operations':
            label = t('pendingTechDec');
            heading = t('reqTechReview');
            color = 'text-pandingOps';
            bgColor = 'bg-pandingOps';
            break;
        case 'pending':
            label = t('pendingConfirmation');
            heading = t('reqNeedsConfirm');
            color = 'text-orange';
            bgColor = 'bg-orange';
            break;
        case 'done':
            label = t('completed');
            heading = t('reqCompleted');
            color = 'text-success';
            bgColor = 'bg-success';
            break;
        case 'active':
            label = t('inProgress');
            heading = t('reqInProgress');
            color = 'text-blue';
            bgColor = 'bg-blue';
            break;
        case 'canceled':
            label = t('canceled');
            heading = t('reqCanceled');
            color = 'text-danger';
            bgColor = 'bg-danger';
            break;
        case 'rejected':
            label = t('rejected');
            heading = t('reqRejected');
            color = 'text-danger';
            bgColor = 'bg-danger';
            break;
    }

    if(type === 'label') {
        return label;
    } else if (type === 'heading') {
        return heading;
    } else if (type === 'bg') {
        return bgColor;
    } else if (type === 'color') {
        return color;
    }


}

export default GetRequestStyle;